import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import LicenseDashboard from './LicenseDashboard';
import DealerOverview from './DealerOverview';

const LicenseDashboardTabs = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const isMaster = localStorage.getItem('isMaster') === 'True';

    return (
        <Box p={2}>
            <Tabs
                value={selectedTab}
                onChange={(_, newValue) => setSelectedTab(newValue)}
                sx={{ mb: 2 }}
            >
                <Tab label="Lizenzen" />
                {isMaster && <Tab label="Händlerübersicht" />}
            </Tabs>

            {selectedTab === 0 && <LicenseDashboard />}
            {selectedTab === 1 && isMaster && <DealerOverview />}
        </Box>
    );
};

export default LicenseDashboardTabs;
